import React from 'react'

import { CommandItem } from '@/components/ui/command'
import { cn } from '@/lib/utils'

/** Delay between each result's pop-in, so they animate in one at a time. */
const POP_IN_STAGGER_MS = 64

interface Props extends React.ComponentProps<typeof CommandItem> {
  /**
   * Position of this result across all groups. Drives the staggered pop-in so
   * results animate in sequentially rather than all at once.
   */
  index: number
}

/**
 * A `CommandItem` that pops in with a staggered delay based on its index.
 * Shared by all the global search result lists.
 */
const SearchResultItem: React.FC<Props> = ({
  index,
  className,
  style,
  ...props
}) => (
  <CommandItem
    className={cn('pop-in', className)}
    style={{
      animationDelay: `${index * POP_IN_STAGGER_MS}ms`,
      animationFillMode: 'both',
      ...style,
    }}
    {...props}
  />
)

export default SearchResultItem
